import { useContext } from "react";
import * as localForage from "localforage";
import { DataContext } from "../../lib/contexts";
import { getDateFromYearWeekDay, intToWeekday } from "../../lib/functions";
import { Action, LF_LAST_FOLDER } from "../../lib/lib";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { MIconButton } from "../elements/miconButton";
import { TEXT_COLOR } from "../../lib/style_definitions";

interface CurrentActionBarProps {
  currentAction: Action;
  onCancel(): void;
}

export function CurrentActionBar(props: CurrentActionBarProps) {
  const { refreshFolders, folders, setSelectedFolder } =
    useContext(DataContext);

  let text = "";

  if (props.currentAction.action === "SELECT_DISH_FOR_FOLDER") {
    text = `Tilføj retter til mappen ${props.currentAction.data.folderName}...`;
  } else if (props.currentAction.action === "SELECT_DISH_FOR_DAY") {
    text = `Tilføj ret til ${intToWeekday(
      props.currentAction.data.day,
    ).toLowerCase()} d. ${getDateFromYearWeekDay(
      props.currentAction.data,
      props.currentAction.data.day,
    )}...`;
  } else if (props.currentAction.action === "SELECT_DAY_FOR_DISH") {
    text = `Vælg dag for ${props.currentAction.data.name}...`;
  } else if (props.currentAction.action === "SELECT_FOLDER_FOR_DISH") {
    text = `Vælg mappe for ${props.currentAction.data.name}`;
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: 76,
        left: 12,
        right: 12,
        zIndex: 5500,
        maxWidth: 520,
        margin: "0 auto",
        background: "white",
        border: "1px solid #e5e7eb",
        boxShadow: "0 12px 32px rgba(55, 65, 81, 0.16)",
        borderRadius: 16,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 12,
        padding: 12,
      }}
    >
      <div
        style={{
          color: TEXT_COLOR,
          fontSize: 15,
          paddingLeft: 4,
          fontWeight: 500,
          lineHeight: 1.35,
        }}
      >
        {text}
      </div>
      {props.currentAction.action === "SELECT_DISH_FOR_FOLDER" ? (
        <MIconButton
          title="Færdig"
          icon={<CheckOutlined />}
          type="primary"
          onClick={async () => {
            const action = props.currentAction;

            if (action.action !== "SELECT_DISH_FOR_FOLDER") {
              return;
            }

            const targetFolder = folders.find(
              (folder) => folder._id === action.data._id,
            );
            setSelectedFolder(targetFolder);
            props.onCancel();

            if (targetFolder) {
              await localForage.setItem(LF_LAST_FOLDER, targetFolder._id);
            }

            await refreshFolders();
          }}
        />
      ) : (
        <MIconButton icon={<CloseOutlined />} onClick={props.onCancel} />
      )}
    </div>
  );
}
